var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4488_5103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 25.8945C17.782 25.8945 18.4167 26.5292 18.4167 27.3112C18.4167 28.0932 17.782 28.7279 17 28.7279C16.218 28.7279 15.5833 28.0932 15.5833 27.3112C15.5833 26.5292 16.218 25.8945 17 25.8945ZM34 28.0195V6.76953C34 3.25478 31.1397 0.394531 27.625 0.394531H6.375C2.86025 0.394531 0 3.25478 0 6.76953V28.0195C0 31.5343 2.86025 34.3945 6.375 34.3945H27.625C31.1397 34.3945 34 31.5343 34 28.0195ZM27.625 1.8112C30.3592 1.8112 32.5833 4.03536 32.5833 6.76953V28.0195C32.5833 30.7537 30.3592 32.9779 27.625 32.9779H6.375C3.64083 32.9779 1.41667 30.7537 1.41667 28.0195V6.76953C1.41667 4.03536 3.64083 1.8112 6.375 1.8112H27.625ZM17.7083 22.3529V21.4377C17.7083 20.1769 18.5782 18.7474 19.7313 18.1114C21.8563 16.9398 22.9996 14.5343 22.5774 12.1245C22.1765 9.84228 20.3037 7.96803 18.0214 7.56853C16.4602 7.29653 14.8991 7.65211 13.6283 8.57295C12.3887 9.47253 11.5543 10.8453 11.3404 12.337C11.2852 12.7238 11.5543 13.0836 11.9411 13.1389C12.3321 13.1955 12.6877 12.9249 12.7429 12.5382C12.9016 11.4233 13.5277 10.3962 14.4599 9.72045C15.4162 9.02486 16.5948 8.75711 17.7763 8.96536C19.482 9.26428 20.8831 10.6654 21.182 12.371C21.5064 14.2127 20.6677 15.9793 19.0485 16.8718C17.425 17.7671 16.2917 19.6456 16.2917 21.4391V22.3543C16.2917 22.7453 16.609 23.0626 17 23.0626C17.391 23.0626 17.7083 22.7453 17.7083 22.3543V22.3529Z",
    fill: "url(#paint0_linear_4488_5103)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4488_5103",
    x1: -4.95833,
    y1: -7.39714,
    x2: 30.4583,
    y2: 34.3945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7410FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4488_5103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0 0.394531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.ec88a40094d87e3bc4f05b7edd9782c0.svg";
export { ForwardRef as ReactComponent };